import { ClientResult } from '@vp/client-result';
import { AuthTokenHeader, FetchClient } from '@vp/fetch-client';

import { ICombination } from '../../../domain/types';
import { configuration } from '../../configurationProvider';
import { encodeObject } from '../../httpCallUtilities';

export async function getStock(
  tenant: string,
  country: string,
  prd: string,
  version: number,
  userSelection: ICombination,
  authorizationHeader: AuthTokenHeader,
  fetchClient: FetchClient
): Promise<ClientResult<MaiseResponse>> {
  const url = `${
    configuration.serviceUrls.maise
  }/v4/product/${prd}/versions/${version}/availability?${encodeObject(
    {
      Merchant: tenant,
      Market: country,
    },
    'context'
  )}&${encodeObject(userSelection, 'attributeSelections')}`;
  return await fetchClient.authenticatedGet<MaiseResponse>(url, authorizationHeader);
}

export interface MaiseResponse {
  facetedAvailabilityStates: FacetedAvailabilityState[];
  availabilityState: AvailabilityState;
  facetedAvailabilityStateContainsDefaultedValues: boolean;
}

interface FacetedAvailabilityState {
  attributeSelections: { name: string; value: string }[];
  availabilityState: AvailabilityState;
}

export interface AvailabilityState {
  inventoryCount?: number;
  statusStates: {
    IsMerchandisable: boolean;
    IsDeliverable: boolean;
    IsRetiredforMerchandising: boolean;
  };
}
